import React, { useState } from 'react'
import { CButton, CSpinner } from '@coreui/react'
import PropTypes from 'prop-types'
import { Document, Page, pdfjs } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const LectorPDF = (props) => {
  const { urlPDF } = props
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }
  const goToFirstPage = () => setPageNumber(1)
  const goToPrevPage = () =>
    pageNumber === 1 ? setPageNumber(numPages) : setPageNumber(pageNumber - 1)
  const goToNextPage = () =>
    pageNumber === numPages ? setPageNumber(1) : setPageNumber(pageNumber + 1)
  const goToLastPage = () => setPageNumber(numPages)

  return (
    <div>
      <Document
        file={urlPDF}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<CSpinner></CSpinner>}
        error="Error al cargar archivo PDF"
        noData="Archivo PDF no especificado"
        className="d-flex justify-content-center"
      >
        <Page
          width="766"
          error="Error al cargar la página"
          loading={<CSpinner></CSpinner>}
          pageNumber={pageNumber}
        />
      </Document>
      <p className="mt-2 d-flex justify-content-center">
        Página {pageNumber} de {numPages}
      </p>
      <nav className="mb-2 d-flex justify-content-center">
        <CButton style={{ marginRight: '0.5rem' }} color="btnRelacionar" onClick={goToFirstPage}>
          Primera
        </CButton>
        <CButton style={{ marginRight: '0.5rem' }} color="btnRelacionar" onClick={goToPrevPage}>
          Anterior
        </CButton>
        <CButton style={{ marginRight: '0.5rem' }} color="btnRelacionar" onClick={goToNextPage}>
          Siguiente
        </CButton>
        <CButton style={{ marginRight: '0.5rem' }} color="btnRelacionar" onClick={goToLastPage}>
          Última
        </CButton>
      </nav>
    </div>
  )
}

LectorPDF.propTypes = {
  urlPDF: PropTypes.string,
}

export default LectorPDF
